/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from 'moment'
import React from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { getAuthors, getSystemAuditLogs } from '../../services/systemAudit'
import { ConfigHeaderExport, ConfigHeaderFilter, ConfigHeaderTimespan } from './components'
import { CleanFiltersButton, ConfigHeaderContainer, FilterTimespanContainer, GenerateButton } from './styles'

interface IProps {
    setTime: (k: string | null) => void
    setStartDay: (k: string | null) => void
    setEndDay: (k: string | null) => void
    setStartHour: (k: string | null) => void
    setEndHour: (k: string | null) => void
    startDay?: string | null
    endDay?: string | null
    startHour?: string | null
    endHour?: string | null
    time?: string | null
    setSystemAuditData: (k: ISystemAudit[]) => void
    isLoading: boolean
    setIsLoading: (k: boolean) => void
    setTotal: (k: number) => void
    perPage: number
    page: number
    filterAuthor: ISelect
    setFilterAuthor: (k: ISelect) => void
    filterStatus: ISelect
    setFilterStatus: (k: ISelect) => void
    filterHttpVerb: ISelect
    setFilterHttpVerb: (k: ISelect) => void
    searchString: string
    setSearchString: (k: string) => void

    setSystemAuditDataToPDF: (k: ISystemAudit[]) => void
}

export const ConfigHeader: React.FC<IProps> = ({
    setTime,
    setStartDay,
    setStartHour,
    setEndDay,
    setEndHour,
    startDay,
    startHour,
    endDay,
    endHour,
    time,
    setSystemAuditData,
    isLoading,
    setIsLoading,
    setTotal,
    perPage,
    page,
    filterAuthor,
    setFilterAuthor,
    filterStatus,
    setFilterStatus,
    filterHttpVerb,
    setFilterHttpVerb,
    searchString,
    setSearchString,
    setSystemAuditDataToPDF
}) => {
    const [authors, setAuthors] = React.useState<string[]>()

    const onClearFilters = (): void => {
        setStartDay('')
        setStartHour('')
        setEndDay('')
        setEndHour('')
        setFilterAuthor({ label: '', value: '' })
        setFilterHttpVerb({ label: '', value: '' })
        setFilterStatus({ label: '', value: '' })
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const isValidToGenerate = (): boolean => {
        return !(isNullEmptyOrUndefined(startDay) || isNullEmptyOrUndefined(endDay))
    }

    const isNullEmptyOrUndefined = (s: string): boolean => {
        return s === null || s === undefined || s.length === 0
    }

    const handleGetSystemAuditData = async (): Promise<void> => {
        if (endDay && endHour && startDay && startHour) {
            try {
                setIsLoading(true)
                const data = await getSystemAuditLogs({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    page: page,
                    perPage: perPage,
                    filterByStatusCodeStatus: filterStatus.value,
                    filterByHTTPVerb: filterHttpVerb.value,
                    filterByLiveAuthor: filterAuthor.value,
                    quickSearch: searchString
                })
                setSystemAuditData(data.data)
                setTotal(data.total)
            } catch (error) {
                globalNotification.error(i18n('An error occurred on listing audit logs'))
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        } else {
            globalNotification.error(i18n('Please select a timespan'))
        }
    }

    const handleGetAuthors = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const data = await getAuthors()
            setAuthors(data)
        } catch (e) {
            globalNotification.error(i18n('An error occurred on listing users'))
        } finally {
            setIsLoading(false)
        }
    }

    React.useEffect(() => {
        handleGetAuthors()
    }, [])

    return (
        <ConfigHeaderContainer>
            <div className="configheader-title" id="configheader-title">
                System Audit
            </div>
            <FilterTimespanContainer>
                <ConfigHeaderTimespan
                    setStartDay={setStartDay}
                    setEndDay={setEndDay}
                    setStartHour={setStartHour}
                    setEndHour={setEndHour}
                    startDay={startDay}
                    endDay={endDay}
                    startHour={startHour}
                    endHour={endHour}
                    generateAuditReport={handleGetSystemAuditData}
                />
                <ConfigHeaderFilter
                    authors={authors}
                    filterAuthor={filterAuthor}
                    setFilterAuthor={setFilterAuthor}
                    filterStatus={filterStatus}
                    setFilterStatus={setFilterStatus}
                    filterHttpVerb={filterHttpVerb}
                    setFilterHttpVerb={setFilterHttpVerb}
                    generateAuditReport={handleGetSystemAuditData}
                    isValidToGenerate={isValidToGenerate()}
                />
                <ConfigHeaderExport
                    startDay={startDay}
                    startHour={startHour}
                    endDay={endDay}
                    endHour={endHour}
                    quickSearch={searchString}
                    filterAuthor={filterAuthor}
                    filterStatus={filterStatus}
                    filterHttpVerb={filterHttpVerb}
                    setSystemAuditDataToPDF={setSystemAuditDataToPDF}
                />
            </FilterTimespanContainer>
        </ConfigHeaderContainer>
    )
}
